import GenericDB from './generic-db'

export default class StripeTokensDB extends GenericDB {
  constructor(userId) {
    super(`/stripe_customers/${userId}/tokens/`)
  }

  // Here you can extend UserPinnedPostsDB with custom methods
}
